import { useMemo } from 'react';
import { Event, Page } from '@/config/track-config';
import { useFm } from '@web3/base-hooks';
import cls from 'classnames';

import styles from './index.module.less';

export const Build = () => {
  const fm = useFm();

  const handleArticle = (url: string) => {
    if (url) {
      window.top?.open(url, '_blank');
    }
  };

  const data = useMemo(
    () => [
      {
        title: fm('listingPartnershipIdoNft'),
        url: 'https://uponly.larksuite.com/share/base/form/shrusE6TYZJGVBO9LOCWCICiWvb',
      },
      {
        title: fm('dAppStoreListing'),
        url: 'https://uponly.larksuite.com/share/base/form/shrusy12cnDPuKJV2JDimh1qvjb',
      },
      {
        title: fm('stakingPartnershipWeb3Earn'),
        url: 'https://forms.gle/Rz9b8TwAU82LCmCPA',
      },
    ],
    [fm]
  );

  return (
    <div className={styles.container}>
      <h1 className={cls('flex items-center', styles.title)}>
        {fm('buildWithUs')}
      </h1>
      <div className={styles.contentBg}>
        <div className={styles.subject}>{fm('buildWithUs')}</div>
        <div className={cls('mt-3', styles.content)}>
          {fm('bybitWeb3IntegrationDoc')}
        </div>
        <div
          className={cls('mt-6', 'cursor-pointer', styles.desc)}
          onClick={() =>
            handleArticle(
              'https://uponly.larksuite.com/share/base/form/shrusiQ3FwkuwGiDcR933kq5lAc'
            )
          }
        >
          {fm('integrateBybitWalletOnDapp')}
        </div>

        <div className={cls('mt-8', styles.subject)}>{fm('join_partner')}</div>
        <div className={cls('mt-3', styles.content)}>
          {fm('join_partner_desc')}
        </div>

        <div className={cls('mt-8', styles.articleBg)}>
          {data.map((item) => {
            const { title, url } = item;
            return (
              <div
                key={title}
                className={cls('transition-all cursor-pointer', styles.article)}
                data-spm-even={Event.Web3UserClick}
                data-spm-data={JSON.stringify({
                  page_name: Page.StakingWebHomepage,
                  button_name: 'Earn_partner',
                })}
                onClick={() => handleArticle(url)}
              >
                {title}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
